
define("rv!templates/layout/ribbon",[],function(){return { v:3,
  t:[ { t:4,
      f:[ { t:7,
          e:"div",
          a:{ runat:"server",
            id:"ribbon",
            "class":"ribbon-bg" },
          f:[ { t:4,
              f:[ { t:7,
                  e:"div",
                  a:{ style:"text-align: center; margin-top: -10px; color: #666;" },
                  f:[ { t:7,
                      e:"p",
                      a:{ style:"font-size: 15px; margin-top: 20px !important;" },
                      f:[ "Keep an eye on your bank statement. You have ",
                        { t:2,
                          r:"user.status.accounts.ReadyForVerification" },
                        " ",
                        { t:2,
                          x:{ r:[ "user.status.accounts.ReadyForVerification" ],
                            s:"_0>1?\"accounts\":\"account\"" } },
                        " ready to be verified. ",
                        { t:7,
                          e:"a",
                          a:{ href:"/myaccount/financialaccount.aspx",
                            "class":"btn btn-small btn-primary",
                            style:"margin-left: 10px;" },
                          f:[ "Go Verify Account" ] } ] } ] } ],
              n:50,
              x:{ r:[ "user.status.accounts.ReadyForVerification" ],
                s:"_0>0" } },
            { t:4,
              n:51,
              f:[ { t:4,
                  n:50,
                  x:{ r:[ "user.status.accounts.FailedTransactions" ],
                    s:"_0>0" },
                  f:[ { t:7,
                      e:"div",
                      a:{ style:"text-align: center; margin-top: -10px; color: #666;" },
                      f:[ { t:7,
                          e:"p",
                          a:{ style:"font-size: 15px; margin-top: 20px !important;" },
                          f:[ "Oops, some banking transactions have gone awry. ",
                            { t:7,
                              e:"a",
                              a:{ href:"/myaccount/financialaccount.aspx",
                                "class":"btn btn-small btn-warning",
                                style:"margin-left: 10px;" },
                              f:[ "Check it out" ] } ] } ] },
                    " " ] },
                { t:4,
                  n:50,
                  x:{ r:[ "user.status.accounts.FailedTransactions",
                      "doneEnrolling" ],
                    s:"(!(_0>0))&&(!_1)" },
                  f:[ " ",
                    { t:7,
                      e:"div",
                      a:{ style:"text-align: center; margin-top: -10px; width: 100%" },
                      f:[ { t:7,
                          e:"p",
                          a:{ id:"enrollmentSteps",
                            "class":"btn-group" },
                          f:[ { t:7,
                              e:"a",
                              a:{ href:"/myaccount/default.aspx",
                                "class":[ "btn",
                                  { t:4,
                                    f:[ " btn-success" ],
                                    n:50,
                                    x:{ r:[ "completedStep" ],
                                      s:"_0(1)&&_0(2)" } } ] },
                              f:[ "My Account Info" ] },
                            " ",
                            { t:7,
                              e:"a",
                              a:{ href:"/myaccount/ACH_Schedule.aspx",
                                "class":[ "btn",
                                  { t:4,
                                    f:[ " btn-success" ],
                                    n:50,
                                    x:{ r:[ "completedStep" ],
                                      s:"_0(4)" } } ] },
                              f:[ "Contribution Schedule" ] },
                            " ",
                            { t:7,
                              e:"a",
                              a:{ href:"/myaccount/financialaccount.aspx",
                                "class":[ "btn",
                                  { t:4,
                                    f:[ " btn-success" ],
                                    n:50,
                                    x:{ r:[ "completedStep" ],
                                      s:"_0(3)" } } ] },
                              f:[ "Linked Account" ] } ] } ] } ] },
                { t:4,
                  n:50,
                  x:{ r:[ "user.status.accounts.FailedTransactions",
                      "doneEnrolling",
                      "user.status.accounts.NotReadyForVerification" ],
                    s:"(!(_0>0))&&((_1)&&(_2>0))" },
                  f:[ " ",
                    { t:7,
                      e:"div",
                      a:{ style:"text-align: center; margin-top: -10px; color: #666;" },
                      f:[ { t:7,
                          e:"p",
                          a:{ style:"font-size: 15px; margin-top: 20px !important;" },
                          f:[ "We're waiting for our bank to validate your account. ",
                            { t:7,
                              e:"a",
                              a:{ href:"/myaccount/financialaccount.aspx",
                                "class":"btn btn-small",
                                style:"margin-left: 10px;" },
                              f:[ "Check Status" ] } ] } ] } ] },
                { t:4,
                  n:50,
                  x:{ r:[ "user.status.accounts.FailedTransactions",
                      "doneEnrolling",
                      "user.status.accounts.NotReadyForVerification" ],
                    s:"(!(_0>0))&&((_1)&&(!(_2>0)))" },
                  f:[ " ",
                    { t:7,
                      e:"div",
                      f:[ { t:7,
                          e:"div",
                          a:{ "class":"holder" },
                          f:[ { t:7,
                              e:"ul",
                              a:{ id:"ribbonsList",
                                "class":"top-info",
                                style:"margin-left: -18px; margin-top: -10px;" },
                              f:[ { t:7,
                                  e:"li",
                                  f:[ { t:7,
                                      e:"a",
                                      a:{ href:"/myaccount/accountsummary" },
                                      f:[ { t:7,
                                          e:"strong",
                                          a:{ "class":"label",
                                            style:"font-size: 21px;" },
                                          f:[ { t:7,
                                              e:"span",
                                              a:{ id:"VacationSavingsBalance" },
                                              f:[ { t:4,
                                                  f:[ "Bon Voyage" ],
                                                  n:50,
                                                  x:{ r:[ "user.ribbon.TotalSavings",
                                                      "user.ribbon.ValueBooked" ],
                                                    s:"_0===0&&_1>0" } },
                                                { t:4,
                                                  n:51,
                                                  f:[ { t:7,
                                                      e:"span",
                                                      a:{ style:"margin: 0px 4px 0px -6px !important; background-position: -90px -76px;",
                                                        "class":"ico-dollar" },
                                                      f:[ "$" ] },
                                                    { t:2,
                                                      x:{ r:[ "formatMoney",
                                                          "user.ribbon.TotalSavings" ],
                                                        s:"_0(_1,true)" } } ],
                                                  x:{ r:[ "user.ribbon.TotalSavings",
                                                      "user.ribbon.ValueBooked" ],
                                                    s:"_0===0&&_1>0" } } ] } ] } ] },
                                    " ",
                                    { t:7,
                                      e:"div",
                                      a:{ "class":"text-holder" },
                                      f:[ { t:7,
                                          e:"b",
                                          f:[ { t:2,
                                              r:"user.member.NameFirst" },
                                            " ",
                                            { t:2,
                                              r:"user.member.NameLast" } ] },
                                        " ",
                                        { t:7,
                                          e:"p",
                                          f:[ "Vacation Saving Balance" ] } ] } ] },
                                " ",
                                { t:4,
                                  f:[ { t:7,
                                      e:"li",
                                      a:{ id:"RibbonValueOfBooked" },
                                      f:[ { t:7,
                                          e:"strong",
                                          a:{ "class":"label label-price" },
                                          f:[ { t:7,
                                              e:"span",
                                              f:[ { t:7,
                                                  e:"span",
                                                  a:{ "class":"ico-dollar",
                                                    style:"background-position: -73px -53px;" },
                                                  f:[ "$" ] },
                                                " ",
                                                { t:7,
                                                  e:"span",
                                                  a:{ "class":"value" },
                                                  f:[ { t:2,
                                                      x:{ r:[ "formatMoney",
                                                          "user.ribbon.ValueBooked" ],
                                                        s:"_0(_1,true)" } } ] } ] } ] },
                                        " ",
                                        { t:7,
                                          e:"div",
                                          a:{ "class":"text-holder" },
                                          f:[ { t:7,
                                              e:"b",
                                              f:[ "Value of Booked Vacations" ] },
                                            " ",
                                            { t:7,
                                              e:"p",
                                              f:[ "Your upcoming vacations" ] } ] } ] } ],
                                  n:50,
                                  x:{ r:[ "user.ribbon.ValueBooked" ],
                                    s:"_0>0" } },
                                " ",
                                { t:4,
                                  f:[ { t:7,
                                      e:"li",
                                      a:{ id:"RibbonVacationSavingsGoal" },
                                      f:[ { t:7,
                                          e:"strong",
                                          a:{ "class":"label label-price label-price-violet" },
                                          f:[ { t:7,
                                              e:"span",
                                              f:[ { t:7,
                                                  e:"span",
                                                  a:{ "class":"ico-dollar" },
                                                  f:[ "$" ] },
                                                " ",
                                                { t:7,
                                                  e:"span",
                                                  a:{ "class":"value" },
                                                  f:[ { t:2,
                                                      x:{ r:[ "formatMoney",
                                                          "user.ribbon.SavingsGoal" ],
                                                        s:"_0(_1,true)" } } ] } ] } ] },
                                        " ",
                                        { t:7,
                                          e:"div",
                                          a:{ "class":"text-holder" },
                                          f:[ { t:7,
                                              e:"b",
                                              f:[ "Vacation Savings Plan" ] },
                                            " ",
                                            { t:7,
                                              e:"p",
                                              f:[ "Left to save for your vacation" ] } ] } ] } ],
                                  n:50,
                                  x:{ r:[ "user.ribbon.SavingsGoal" ],
                                    s:"_0>0" } } ] } ] } ] } ] } ],
              x:{ r:[ "user.status.accounts.ReadyForVerification" ],
                s:"_0>0" } } ] } ],
      n:50,
      x:{ r:[ "user" ],
        s:"_0!=null" } } ] };});
